export const USERS_CSV_HEADERS = [
  { label: 'User ID', key: 'id' },
  { label: 'Name', key: 'name' },
  { label: 'Email', key: 'email' },
  { label: 'Role', key: 'role' },
  { label: 'Joined Date', key: 'createDate' },
];

export const UserRole = {
  superAdmin: 'superAdmin',
  user: 'user',
  vendor: 'vendor',
} as const;
